<template>
  <a class="d-block" :href="item.url" target="_blank">
    <v-img :src="item.image"/>
  </a>
</template>

<script>
export default {
  name: 'CItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
